module.exports = __webpack_public_path__ + "img/benson-city-logo.4730c9b0.jpg";